import React from "react";
import styles from "./contact.module.css";
import Navbar from "../../Components/Navbar/Navbar";
import {
  Heading,
  Paragraph,
} from "../../Components/TextComponents/TextComponents";
import { Container, Row, Col } from "react-bootstrap";
import FormSection from "../../Components/FormSection/FormSection";
import AccordinanSection from "../../Components/AccordinanSection/AccordinanSection";


const Contact = () => {
  return (
    <React.Fragment>
      <div className={styles.main_section}>
        <Navbar />
        <Container>
          <Row>
            <Col md={6}>
              <div className={styles.hero_section}>
                <Heading color="#fff"> Get in Touch with Us</Heading>
                <Paragraph color="#fff">
                  We’re here to help you with all your global trade needs. Let’s
                  connect and create solutions together.
                </Paragraph>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {/* -----------queries-section-start--------- */}
      <Container>
        <Row>
          <Col md={12} sm={12}>
            <div className={styles.queries_section}>
              <Heading>
                {" "}
                Have questions, need support <br /> Or Any Query ?
              </Heading>
              <Paragraph>
                Or want to explore partnership opportunities? The CrossBorder
                BTC <br /> team is ready to assist you. Whether you’re a buyer,
                supplier, or <br /> potential partner, we’re just a click or
                call away
              </Paragraph>
              <img loading="lazy" src="/images/contact/user.png" alt="user" />
            </div>
          </Col>
        </Row>
      </Container>
      {/* -----------queries-section-end----------- */}
      <FormSection />

      {/* -----------Location-section-start--------- */}
      <div className={styles.location_section}>
      <Container>
        <div>
          <Heading>Locate Us on the Map</Heading>
          <Paragraph>
            Find us easily at our headquarters, just 5 minutes away from <br />{" "}
            HUDA Metro Station, Gurugram.
          </Paragraph>
        </div>
      </Container>

      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14032.614362650638!2d77.04522789350256!3d28.444786073045055!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d188cc879194d%3A0x71d199d693c2f473!2sGreenwood%20City%2C%20Sector%2045%2C%20Gurugram%2C%20Haryana%20122022!5e0!3m2!1sen!2sin!4v1737010677342!5m2!1sen!2sin"
        width="100%"
        height="450"
        className="mt-3"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
         title="Google Maps showing Greenwood City, Sector 45, Gurugram, Haryana"
      ></iframe>
         </div>
      {/* -----------Location-section-end--------- */}
      {/* ------------section-start--------- */}
      <div className={styles.trade_section}>
        <Container>
          <Row>
            <Col md={3} sm={12}>
              <div className={styles.section}>
                <h6>Office Address:</h6>
                <span>A211, Greenwood City, Sector 45, Gurugram, India</span>
              </div>
            </Col>
            <Col md={3} sm={12}>
              <div className={styles.section}>
                <h6>Email:</h6>
                <p>
                  meena@crossborderbtc.
                  <br />
                  com
                </p>
              </div>
            </Col>
            <Col md={3} sm={12}>
              <div className={styles.section}>
                <h6>Phone:</h6>
                <p>+91-124-4059332</p>
                <p>+91-8826710292</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {/* ------------section-end--------- */}
      <AccordinanSection />
    </React.Fragment>
  );
};

export default Contact;
